/**
 * TypeEditorResolver manages custom content type editors.
 * These are full-page editors that replace the default group-based layout
 * for specific content types (like StoreProduct).
 */

// Create a map of content types to their custom editor components
const typeEditorMap = {}

/**
 * Get a custom editor component for a content type
 * @param {string} typeName - The name of the content type or custom editor
 * @returns {React.Component|undefined} The editor component or undefined if not found
 */
const getTypeEditor = (typeName) => {
  if (!typeName) return undefined
  return typeEditorMap[typeName]
}

/**
 * Register a custom editor component for a content type
 * @param {string} typeName - The name of the content type or custom editor
 * @param {React.Component} editor - The editor component
 */
const addTypeEditor = (typeName, editor) => {
  typeEditorMap[typeName] = editor
}

/**
 * Check if a content type has a custom editor registered
 * @param {string} typeName - The name of the content type
 * @returns {boolean} True if a custom editor exists
 */
const hasTypeEditor = (typeName) => {
  return !!typeEditorMap[typeName]
}

export { getTypeEditor, addTypeEditor, hasTypeEditor }
